const accordionBtns = document.querySelectorAll(".accordion-btn");
const accordionPanels = document.querySelectorAll(".accordion-panel");

export default function init () {
  
accordionBtns.forEach((btn, index) => {
  document.addEventListener("click", (btnClick) => {
    if (btnClick.target === btn) {
      let panel = accordionPanels[index];
      panel.classList.toggle('open-accordion');
      btn.classList.toggle('open-accordion');
      if (panel.style.maxHeight) {
        panel.style.maxHeight = 0;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    }
  })
})
  
  
}